import React from 'react'
import FeatherSVG from './FeatherSVG'

const Info = props => (
  <FeatherSVG {...props}>
    <title>info</title>
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="16" x2="12" y2="12" />
    <line x1="12" y1="8" x2="12" y2="8" />
  </FeatherSVG>
)

export default Info
